<template>
  <section aid="node-pool-row" class="node-pool-row">
    <quota-tab-content
      v-show="isSelectedTabQuota"
      :model="model"
      :options="options"
      @update-node-pool-over-quota="$emit(ENodePoolRowEmitName.UpdateNodePoolOverQuota, $event)"
      @update-node-pool-resource="$emit(ENodePoolRowEmitName.UpdateNodePoolResource, $event)"
    />
    <scheduling-tab-content
      v-show="!isSelectedTabQuota"
      :model="model"
      :options="options"
      @update-node-pool-over-quota="$emit(ENodePoolRowEmitName.UpdateNodePoolOverQuota, $event)"
      @update-node-pool-resource="$emit(ENodePoolRowEmitName.UpdateNodePoolResource, $event)"
      @update-priority="$emit(ENodePoolRowEmitName.UpdateEntityPriority, $event)"
    />
  </section>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

//model
import type { EResourceType } from "@/models/resource.model";
// cmps
import { EQuotaTab, type NodePoolModel, type NodePoolOptions } from "@/models/org-unit.model";
import { QuotaTabContent } from "@/components/org-unit/quota-management/node-pools-table/node-pool-row/quota-tab-content";
import { SchedulingTabContent } from "@/components/org-unit/quota-management/node-pools-table/node-pool-row/scheduling-tab-content";

export enum ENodePoolRowEmitName {
  UpdateNodePoolPriority = "update-node-pool-priority",
  UpdateEntityPriority = "update-priority",
  UpdateNodePoolResource = "update-node-pool-resource",
  UpdateNodePoolOverQuota = "update-node-pool-over-quota",
}

export default defineComponent({
  components: {
    SchedulingTabContent,
    QuotaTabContent,
  },
  emits: {
    [ENodePoolRowEmitName.UpdateNodePoolPriority]: (payload: { value: string | number; name: string }) => payload,
    [ENodePoolRowEmitName.UpdateNodePoolResource]: (payload: {
      name: string;
      resourceType: EResourceType;
      resourceValue: number | null;
    }) => payload,
    [ENodePoolRowEmitName.UpdateNodePoolOverQuota]: (payload: { name: string; overQuota: number }) => payload,
    [ENodePoolRowEmitName.UpdateEntityPriority]: (payload: { name: string; priority: string }) => payload,
  },
  props: {
    options: {
      type: Object as PropType<NodePoolOptions>,
      required: true,
    },
    model: {
      type: Object as PropType<NodePoolModel>,
      required: true,
    },
  },
  computed: {
    ENodePoolRowEmitName(): typeof ENodePoolRowEmitName {
      return ENodePoolRowEmitName;
    },
    isSelectedTabQuota(): boolean {
      return this.options.selectedTab === EQuotaTab.Quota;
    },
  },
});
</script>
<style scoped lang="scss">
.node-pool-row {
  width: 100%;
}
</style>
